import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

import PaymentTimeline from '@spotahome/ui-library/src/tenant/components/PaymentTimeline';
import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';

import {
  useDisplayListingPricing,
  usePricingContext
} from '@spotahome/marketplace-common/src/context/PricingContext';
import {
  OPEN_BOOKNOW_DATEPICKER_DESKTOP,
  OPEN_BOOKNOW_DATEPICKER_MOBILE
} from '@spotahome/marketplace-common/src/channels';

import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';

import './ListingPaymentTimeline.scss';

const ListingPaymentTimeline = ({ listing = {} }) => {
  const { pricingDetails, downPaymentTimeInterval, hasNoDeposit } =
    usePricingContext();
  const { price: listingPrice } = useDisplayListingPricing();

  const { isBiggerThanTablet } = useMediaQuery();
  const selectDatesChannel = isBiggerThanTablet()
    ? OPEN_BOOKNOW_DATEPICKER_DESKTOP
    : OPEN_BOOKNOW_DATEPICKER_MOBILE;

  const handleOnSelectDatesClick = () => Mediator.publish(selectDatesChannel);

  const pricing = pricingDetails?.pricing;

  return (
    <ListingSectionObservable section="pricing">
      <ListingTitle
        role="secondary"
        className="listing-payment-timeline__title"
      >
        {trans('listing.payment.timeline.title')}
      </ListingTitle>
      <p className="listing-payment-timeline__description">
        {trans('listing.payment.timeline.description')}
      </p>
      <PaymentTimeline
        listingCosts={{
          ...pricing?.listingCosts,
          extra: pricing?.listingCosts?.extra || listing?.listingCosts?.extra
        }}
        pricing={pricing}
        offers={listing?.offers}
        downPaymentTimeInterval={downPaymentTimeInterval}
        onSelectDates={handleOnSelectDatesClick}
        hasNoDeposit={hasNoDeposit}
        listingMonthlyPrice={listingPrice}
        currencyIsoCode={
          pricing?.currencyIsoCode || listing.pricing.currencyLabel
        }
        isInstantBooking={listing?.instantBooking?.isEnabled}
      />
    </ListingSectionObservable>
  );
};

ListingPaymentTimeline.propTypes = {
  listing: PropTypes.shape({
    offers: PropTypes.arrayOf(PropTypes.shape({}))
  })
};

export default ListingPaymentTimeline;
